export default __webpack_public_path__ + "images/6543f48f741a189763d9da83c44504dd.png";